import { create } from 'zustand';

import { IStartWorkflowState, initialStartWorkflowState } from 'pages/StartWorkflowRunPage/pageState/state';

import { IZipState, initialZipState } from 'shared/ZipProgresses/zipState';

// Types
import IAsync from 'types/IAsync';
import IAuthState from 'types/IAuthState';
import IUser from 'types/IUser';
import IAccount from 'types/IAccount';
import IProject from 'types/IProject';
import IRunEntry from 'types/IRunEntry';
import IRunDetails from 'types/IRunDetails';
import IWorkflowProgress from 'types/IWorkflowProgress';
import IPaginatedResponse from 'types/IPaginatedResponse';
import IRunFile from 'types/IRunFile';
import ITaskDetails from 'types/ITaskDetails';
import INodeAgent from 'types/INodeAgent';
import IWorkflowDefinition from 'types/IWorkflowDefinition';
import IWorkflowDefinitionDetails from 'types/IWorkflowDefinitionDetails';
import IUserSummary from 'types/IUserSummary';
import IDashboardTaskCounts from 'types/IDashboardTaskCounts';
import IWorkflowErrorSummary from 'types/IWorkflowErrorSummary';

type Id = string;

export interface State {
  authStateAsync: IAsync<IAuthState>;
  profileAsync: IAsync<IUser>;
  accountsAsync: IAsync<IAccount[]>;

  projectsAsync: IAsync<IProject[]>;
  nodesAsync: IAsync<INodeAgent[]>;

  projectStateMap: Record<Id, IProjectState>;

  dashboard: IDashboardState;

  startWorkflow: IStartWorkflowState;

  zipState: IZipState;
}

export interface IDashboardState {
  runsAsync: IAsync<IPaginatedResponse<IRunEntry>>;
  usersAsync: IAsync<IUserSummary[]>;
  taskCountsAsync: IAsync<IDashboardTaskCounts>;
  errorSummaryAsyncMap: Record<Id, IAsync<IWorkflowErrorSummary>>;
}

export interface IProjectState {
  usersAsync: IAsync<IUser[]>;
  runsAsync: IAsync<IPaginatedResponse<IRunEntry>>;
  runDetailsAsyncMap: Record<Id, IAsync<IRunDetails>>;
  runFilesAsyncMap: Record<Id, IAsync<IPaginatedResponse<IRunFile>>>;
  taskDetailsAsyncMap: Record<Id, IAsync<ITaskDetails>>;
  workflowProgressAsyncMap: Record<Id, IAsync<IWorkflowProgress>>;
  workflowDefinitionsAsync: IAsync<IWorkflowDefinition[]>;
  workflowDefinitionDetailsAsyncMap: Record<Id, IAsync<IWorkflowDefinitionDetails>>;
}

// Store
const useStore = create<State>(() => ({
  authStateAsync: { status: 'INIT' },
  profileAsync: { status: 'INIT' },
  accountsAsync: { status: 'INIT' },

  projectsAsync: { status: 'INIT' },
  nodesAsync: { status: 'INIT' },

  projectStateMap: {},

  dashboard: {
    runsAsync: { status: 'INIT' },
    usersAsync: { status: 'INIT' },
    taskCountsAsync: { status: 'INIT' },
    errorSummaryAsyncMap: {},
  },

  startWorkflow: initialStartWorkflowState,

  zipState: initialZipState,
}));

export { useStore };
export default useStore;

if (import.meta.env.DEV) {
  (window as Window & { store?: typeof useStore }).store = useStore;
}
